import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class BondService {
    constructor(
        private http_client: ApiService,
    ) { }

    async getBondNos(params: string): Promise<any> {
        try {
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/List/comments/bondnos?${params}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async saveBondSpecificComment(data: any, company_name: string): Promise<any> {
        try {
            const response: any = await this.http_client.postData(Constant.new_base_url +
                "api/Comments", data);
            if (company_name !== null) {

                response.commentsResponse.company_name = company_name;
                localStorage.setItem(
                    'OpenNotesObject',
                    response ? btoa(JSON.stringify(response.commentsResponse)) : ''
                );
            }
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async saveOpenItems(data: any): Promise<any> {
        try {
            const response: any = await this.http_client.postData(Constant.new_base_url +
                "api/OpenItems", data);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    getOpenNoteObject() {
        try {
            if (localStorage.getItem('OpenNotesObject') !== null && localStorage.getItem('OpenNotesObject') !== '') {
                return JSON.parse(atob(localStorage.getItem('OpenNotesObject')));
            } else {
                return null;
            };
        } catch (error) {
            return null;
        }

    }

    destroyOpenNoteObject() {
        window.localStorage.removeItem('OpenNotesObject');
    }

    saveSearchBondObject(bondObject: any) {
        try {
            localStorage.setItem(
                'searchBondObj',
                bondObject ? btoa(JSON.stringify(bondObject)) : ''
            );
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    getSearchBondObject() {
        try {
            if (localStorage.getItem('searchBondObj') !== null && localStorage.getItem('searchBondObj') !== '') {
                return JSON.parse(atob(localStorage.getItem('searchBondObj')));
            } else {
                return null;
            };
        } catch (error) {
            return null;
        }
    }

    destroySearchBondObject() {
        window.localStorage.removeItem('searchBondObj');
    }

    async getOpenItemsByClient(company_name: string, status: string): Promise<any> {
        try {
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/OpenItems/client/${company_name}/${status}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateOpenItems(data: any): Promise<any> {
        try {
            const response: any = await this.http_client.putData(Constant.new_base_url +
                `api/OpenItems`, data);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getBondDetails(data: any): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.postData(Constant.new_base_url +
                `api/Bond/GetBond`, data);
            console.log('headers', response.headers);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getEditBondDetails(data: any): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.postData(Constant.new_base_url +
                `api/Bond/GetEditBond`, data);
            console.log('headers', response.headers);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getBondSpecificRiders(bondNo: string): Promise<any> {
        try {
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/Riders/bond/${bondNo}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getBondSpecificComments(bondNo: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/Comments/bond/${bondNo}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getBondSpecificOpenItems(bondNo: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/OpenItems/bond/${bondNo}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getBondOpenItemsByClient(client: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/OpenItems/bond/client/${client}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getBondOpenItemsByDivision(divsion: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/OpenItems/bond/division/${divsion}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getBondOpenItemsBySubDivision(subdivsion: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/OpenItems/bond/subdivision/${subdivsion}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getSurtyContractsBySuretyBranch(suretyBranch: string): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/UnderwriterContacts/bond/${suretyBranch}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async editBond(data: any): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.putData(Constant.new_base_url +
                `api/Bond`, data);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async addBond(data: any): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.postData(Constant.new_base_url +
                `api/Bond`, data);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    saveAddBondObject(bondObject: any) {
        try {
            localStorage.setItem(
                'AddBondObj',
                bondObject ? btoa(JSON.stringify(bondObject)) : ''
            );
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    getAddBondObject() {
        try {
            if (localStorage.getItem('AddBondObj') !== null && localStorage.getItem('AddBondObj') !== '') {
                return JSON.parse(atob(localStorage.getItem('AddBondObj')));
            } else {
                return null;
            };
        } catch (error) {
            return null;
        }
    }

    destroyAddBondObject() {
        window.localStorage.removeItem('AddBondObj');
    }

    async getAddBondNo(suretyBranch: string, suretyPaper: string) {
        try {
            debugger
            const response: any = await this.http_client.getData(Constant.new_base_url +
                `api/Bond/BondNo?SuretyBranch=${suretyBranch}&SuretyPaper=${suretyPaper}`);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async importBond(formdata: FormData): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.postData(Constant.new_base_url +
                `api/Import/ImportBondNos`, formdata);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async importClientBond(formdata: FormData): Promise<any> {
        try {
            debugger
            const response: any = await this.http_client.postData(Constant.new_base_url +
                `api/Import/ImportClientBonds`, formdata);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async exportClientBond(clientName:string): Promise<any> {
        try {
            debugger
            const httpOptions = {
                responseType: 'blob' as 'json',
              };
            const response: any = await this.http_client.get(Constant.new_base_url +
                `api/Import/ExportClientBonds/${clientName}`,undefined,undefined,httpOptions);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async exportAllBond(): Promise<any> {
        try {
            debugger
            const httpOptions = {
                responseType: 'blob' as 'json',
              };
            const response: any = await this.http_client.get(Constant.new_base_url +
                `api/Import/ExportBondNos`,undefined,undefined,httpOptions);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    
}